import React from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';
import { FaInfinity, FaCalendar, FaDollarSign, FaHashtag, FaClock } from 'react-icons/fa';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './DiscountLimits.scss';

interface DiscountLimitsProps {
  limitType: string;
  setLimitType: (type: string) => void;
  selectedExpirationDate: Date | null;
  setSelectedExpirationDate: (date: Date | null) => void;
  showCalendar: boolean;
  setShowCalendar: (show: boolean) => void;
  maxBudget: number | null;
  setMaxBudget: (budget: number | null) => void;
  maxNumber: number | null;
  setMaxNumber: (number: number | null) => void;
}

const DiscountLimits: React.FC<DiscountLimitsProps> = ({
  limitType,
  setLimitType,
  selectedExpirationDate,
  setSelectedExpirationDate,
  showCalendar,
  setShowCalendar,
  maxBudget,
  setMaxBudget,
  maxNumber,
  setMaxNumber
}) => {
  return (
    <div className="form-section limit-section">
      <div className="section-title">
        <FaClock className="section-icon" />
        Límites y restricciones
      </div>
      
      <div className="limit-options">
        <div
          className={`limit-option ${limitType === 'Sin limite' ? 'active' : ''}`}
          onClick={() => setLimitType('Sin limite')}
        >
          <div className="limit-header">
            <div className="limit-icon">
              <FaInfinity />
            </div>
            <div className="limit-title">Sin límite</div>
          </div>
          <div className="limit-description">Puede usarse indefinidamente</div>
        </div>

        <div
          className={`limit-option ${limitType === 'Fecha limite' ? 'active' : ''}`}
          onClick={() => setLimitType('Fecha limite')}
        >
          <div className="limit-header">
            <div className="limit-icon">
              <FaCalendar />
            </div>
            <div className="limit-title">Fecha límite</div>
          </div>
          <div className="limit-description">Expira en fecha específica</div>
        </div>

        <div
          className={`limit-option ${limitType === 'Presupuesto máximo' ? 'active' : ''}`}
          onClick={() => setLimitType('Presupuesto máximo')}
        >
          <div className="limit-header">
            <div className="limit-icon">
              <FaDollarSign />
            </div>
            <div className="limit-title">Presupuesto máximo</div>
          </div>
          <div className="limit-description">Se desactiva al alcanzar monto total</div>
        </div>

        <div
          className={`limit-option ${limitType === 'Número de usos' ? 'active' : ''}`}
          onClick={() => setLimitType('Número de usos')}
        >
          <div className="limit-header">
            <div className="limit-icon">
              <FaHashtag />
            </div>
            <div className="limit-title">Número de usos</div>
          </div>
          <div className="limit-description">Se desactiva después de cierta cantidad</div>
        </div>
      </div>

      {/* Conditional inputs based on limit type */}
      {limitType === 'Fecha limite' && (
        <div className="calendar-container">
          <Form.Group className="mp-formgroup horizontal">
            <Form.Label>Fecha de expiración:</Form.Label>
            <Button
              variant="none"
              onClick={() => setShowCalendar(!showCalendar)}
              className="boton-show-calendar-discounts"
            >
              {selectedExpirationDate 
                ? selectedExpirationDate.toLocaleDateString() 
                : 'Seleccionar fecha'
              }
              <FaCalendar />
            </Button>
          </Form.Group>
          
          {showCalendar && (
            <div className="mp-form-calendar-container">
              <Calendar
                onChange={(date) => {
                  setSelectedExpirationDate(date as Date);
                  setShowCalendar(false);
                }}
                value={selectedExpirationDate}
                locale="es-ES"
                className="mp-form-calendar"
                minDate={new Date()}
              />
            </div>
          )}
        </div>
      )}

      {limitType === 'Presupuesto máximo' && (
        <Form.Group className="mp-formgroup horizontal">
          <Form.Label>Monto máximo total:</Form.Label>
          <InputGroup>
            <InputGroup.Text className="signo">$</InputGroup.Text>
            <Form.Control
              type="number"
              min="0"
              value={maxBudget !== null ? maxBudget : ''}
              onChange={(e) => setMaxBudget(Math.max(0, Number(e.target.value)))}
              required
              placeholder="Ej: 50000"
            />
          </InputGroup>
        </Form.Group>
      )}

      {limitType === 'Número de usos' && (
        <div className="limit-input-section">
          <Form.Group className="mp-formgroup">
            <Form.Control
              type="number"
              value={maxNumber !== null ? maxNumber : ''}
              onChange={(e) => setMaxNumber(Number(e.target.value))}
              placeholder="Ej: 100"
              className="limit-input"
              min="1"
            />
          </Form.Group>
        </div>
      )}
    </div>
  );
};

export default DiscountLimits;
